import React from 'react';

import './Layout.css';
import BasicInformations from './BasicInformations';
import Sumary from './Sumary';
import ContactInfo from './ContactInfo';
import Expectations from './Expectations';
import Experience from './Experience';
import ExperienceSummary from './ExperienceSummary';
import Education from './Education';
import Language from './Language';
import Skills from './Skills';
import Courses from './Courses';
import Organizations from './Organizations';
import Hobby from './Hobby';
import Links from './Links';

const Layout = () => {
  return (
    <div className="container profile-layout">
      <div className="row">
        <div className="col col-12 col-lg-8 col-xl-9">
          <BasicInformations />
          <ContactInfo />
          <Expectations />
          <Experience />
          <ExperienceSummary />
          <Education />
          <Language />
          <Skills />
          <Courses />
          <Organizations />
          <Hobby />
          <Links />
        </div>
        <div className="col col-12 col-lg-4 col-xl-3">
          <Sumary />
        </div>
      </div>
    </div>
  );
};

export default Layout;
